import type { TModule } from '@modules/core/types';

import { TREASURY_ROUTE_PATHS } from './config';
import { TRANSFERS_ROUTE_PATHS } from './transfers/config';
import { CREDENCIAL_ACCOUNTS_ROUTES } from './credencial-accounts';
import { TRANSFERS_ROUTES } from './transfers';

const treasuryModule: TModule = {
  id: 'treasury',
  fallbackRoute: [TREASURY_ROUTE_PATHS.credencialAccounts],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...CREDENCIAL_ACCOUNTS_ROUTES, ...TRANSFERS_ROUTES],
};

// Merge both path objects so prefixPaths() in modules.ts applies PLATFORM_PREFIX
// to all treasury routes (credencial-accounts + transfers).
export const TreasuryRoutePaths = {
  ...TREASURY_ROUTE_PATHS,
  ...TRANSFERS_ROUTE_PATHS,
};

export default treasuryModule;
